import { httpRequest } from "@services/http";
import type { LaunchPickerParams, LaunchesForFilterResponse } from "../models/dashboard";
import { legacyDashboardUrl } from "./legacyDashboardUrl";

export class CommandGetLaunchesForFilter {
    async run(params: LaunchPickerParams): Promise<LaunchesForFilterResponse> {
        const url = legacyDashboardUrl("reporting/get-launches-for-filter/");
        Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value));
        return await httpRequest<LaunchesForFilterResponse>(url.toString());
    }
}
